module.exports = __webpack_public_path__ + "img/1.6b03d6c7.png";